var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBetaeubungsmittel = function SvgBetaeubungsmittel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.647,
    height: 70.694
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M10.976 0h4.91a10.976 10.976 0 0 1 10.976 10.976V34.35H0V10.976A10.976 10.976 0 0 1 10.976 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M0 36.344h26.862v23.375a10.976 10.976 0 0 1-10.976 10.975h-4.91A10.976 10.976 0 0 1 0 59.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.19 57.263a9.67 9.67 0 0 1-1.545 5.786 10.1 10.1 0 0 1-4.774 3.836 9.98 9.98 0 0 1-6.198.332 10.17 10.17 0 0 1-7.543-9.2c-.039-2.078.018-4.015.07-6.028l.171-5.987c.102-1.996.162-3.991.3-5.987.14 1.996.199 3.991.3 5.987l.171 5.987c.085 1.976.038 4.034.143 5.944a9.25 9.25 0 0 0 2.075 5.126 9.41 9.41 0 0 0 10.195 2.944 9.83 9.83 0 0 0 6.636-8.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M45.785 36.344h26.862v23.375A10.976 10.976 0 0 1 61.67 70.694h-4.91A10.976 10.976 0 0 1 45.784 59.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M56.76 0h4.91a10.976 10.976 0 0 1 10.977 10.976V34.35H45.785V10.976A10.976 10.976 0 0 1 56.76 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.976 13.431a9.67 9.67 0 0 0-1.546-5.786 10.1 10.1 0 0 0-4.775-3.835 9.98 9.98 0 0 0-6.197-.332 10.17 10.17 0 0 0-7.544 9.2c-.038 2.078.019 4.014.072 6.028l.17 5.987c.102 1.995.161 3.99.3 5.986.139-1.995.198-3.99.3-5.986l.17-5.987c.086-1.977.039-4.034.144-5.944a9.25 9.25 0 0 1 2.075-5.127 9.41 9.41 0 0 1 10.194-2.943 9.83 9.83 0 0 1 6.637 8.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M15.436.166a14.3 14.3 0 0 1 6.219 11.806v46.75a14.3 14.3 0 0 1-6.22 11.807 13.42 13.42 0 0 0 11.427-13.266V13.431A13.42 13.42 0 0 0 15.436.166M61.028.166a14.3 14.3 0 0 1 6.22 11.806v46.75a14.3 14.3 0 0 1-6.22 11.807 13.42 13.42 0 0 0 11.426-13.266V13.431A13.42 13.42 0 0 0 61.028.166",
    opacity: 0.15
  }))));
};
export default SvgBetaeubungsmittel;